import   axios                       from 'axios';

import { getUserAgentInformations ,
         getAppInformations       }  from './utils';	

import { API_URLS                 }  from './urls';

export interface PostInformationRequestResult {
  code:    number,
  comment: string
}

export const postInformationRequest = async ( firstname:   string ,
                                              lastname:    string ,
                                              age:         number ,
                                              email:       string ,
                                              phoneNumber: string ,
                                              city:        string ,
                                              subject:     string ): Promise<PostInformationRequestResult> => {

    console.log ( "postInformationRequest " , firstname, lastname, email, phoneNumber, city );

	const userAgentInformations = getUserAgentInformations ();
	const appInformations       = getAppInformations ();
	
    const headers = {
        'Accept': 'application/ld+json',
        'Content-Type': 'application/ld+json',
	    'User-Agent-Informations': `${userAgentInformations}`,
	    'App-Informations': `${appInformations}`,
    };
	
	var result:PostInformationRequestResult = {
      code:    0,
      comment: "",
    };
		
    try {

        const response = await axios.post (
        
                                            `${API_URLS.postInformationRequest}`,
                              
                                            { 
                                              firstname   ,
                                              lastname    ,
                                              age         ,
                                              email       ,
											  phoneNumber ,
                                              city        ,
											  subject                  											 
                                            },
                                            
                                            {
                                              headers: headers
                                            }
                                          );

        console.log ( "postInformationRequest " , response );

		if ( response.status === 201 )
		      { 
			   result = {
		         code:            1 ,
		         comment: "Demande d'information envoyée" ,
		       };
			  }
		 else {
			   result = {
		         code:     -101 ,
		         comment: `Erreur lors de la création de la demande d'information ${response.status}`,
		       };
			  }

    } 
    catch (error) {

        console.log ( "postInformationRequest " , error );

        result = {
		  code:    -201,
		  comment: "Erreur réseau",
		}; 
    }

	return result;
};


export interface PostUrbanTourRegistrationResult {
  code:    number,
  comment: string,
  id:      number
}

export const postUrbanTourRegistration = async ( destination                : string  ,
                                                 sessionDates               : string  ,
	                                             sex                        : string  ,
	                                             firstname                  : string  ,
	                                             lastname                   : string  ,
	                                             email                      : string  ,
	                                             phoneNumber                : string  ,
	                                             birthday                   : string  ,
	                                             address                    : string  ,
	                                             address2                   : string  ,
	                                             zipCode                    : string  ,
	                                             city                       : string  ,
	                                             country                    : string  ,
	                                             identityDocument           : string  ,
	                                             identityDocumentValidity   : string  ,
	                                             nationality                : string  ,
	                                             contactRequest             : boolean ): Promise<PostUrbanTourRegistrationResult> => {


	const userAgentInformations = getUserAgentInformations ();
	const appInformations       = getAppInformations ();

    const headers = {
        'Accept': 'application/ld+json',
        'Content-Type': 'application/ld+json',
	    'User-Agent-Informations': `${userAgentInformations}`,
	    'App-Informations': `${appInformations}`,
    };

	var result:PostUrbanTourRegistrationResult = {
      code:    0,
      comment: "",
	  id:      0
    };

    try {

        console.log ( "postUrbanTourRegistration ", `${API_URLS.postUrbanTourRegistration}` );

        const response = await axios.post (

                                            `${API_URLS.postUrbanTourRegistration}`,

                                            {
                                              destination                ,
	                                          sessionDates               ,
	                                          sex                        ,
										      firstname                  ,
	                                          lastname                   ,
										      email                      ,
	                                          phoneNumber                ,
	                                          birthday                   ,
	                                          address                    ,
	                                          address2                   ,
	                                          zipCode                    ,
	                                          city                       ,
	                                          country                    ,
	                                          identityDocument           ,
	                                          identityDocumentValidity   ,
	                                          nationality                ,
	                                          contactRequest
                                            },

                                            {
                                              headers: headers
                                            }
                                          );

        console.log ( "postUrbanTourRegistration " , response );

		if ( response.status === 201 )
		      {
			   result = {
		         code:            1 ,
		         comment: "Demande d'information envoyée" ,
				 id:      response.data.id
		       };
			  }
		 else {
			   result = {
		         code:     -101 ,
		         comment: `Erreur lors de l'enregistrement à l'urban tour ${response.status}`,
				 id:       0
		       };
			  }

    }
    catch (error) {

        console.log ( "postUrbanTourRegistration " , error );

        result = {
		  code:    -201,
		  comment: "Erreur réseau",
		  id:       0
		};
    }

	return result;
};
